import { supabase } from "@/integrations/supabase/client";
import { extractSKUs } from "@/utils/skuExtractor";
import { lookupProductsBySKUs } from "./productLookupService";
import { isAwaitingStockStatus } from "@/utils/statusMappings";

export const addAutoMonitoringForNotification = async (
  notificationId: string,
  message: string,
  status: string
): Promise<void> => {
  // Only auto-add for awaiting stock statuses
  if (!isAwaitingStockStatus(status)) {
    console.log('Status not awaiting stock, skipping auto-monitoring');
    return;
  }
  
  // Extract SKUs from message
  const skus = extractSKUs(message);
  
  if (skus.length === 0) {
    console.log('No SKUs found in message, skipping auto-monitoring');
    return;
  }
  
  console.log(`Found ${skus.length} SKU(s) in message:`, skus);
  
  // Lookup products
  const products = await lookupProductsBySKUs(skus);
  
  if (products.length === 0) {
    console.log('No products found in voorraad_live for SKUs:', skus);
    return;
  }
  
  console.log(`Found ${products.length} product(s) in voorraad_live`);
  
  // Check if monitoring already exists for this notification
  const { data: existing } = await supabase
    .from('notification_product_monitoring')
    .select('id')
    .eq('notification_id', notificationId)
    .limit(1);
  
  if (existing && existing.length > 0) {
    console.log('Monitoring already exists for notification, skipping');
    return;
  }

  // Insert into monitoring
  const monitoringData = products.map(product => ({
    notification_id: notificationId,
    product_name: product.product_name,
    product_sku: product.product_sku,
    product_bc: product.product_bc,
    product_quantity: 1,
    product_color: '',
    is_monitored: true
  }));
  
  const { error } = await supabase
    .from('notification_product_monitoring')
    .insert(monitoringData)
    .select();
  
  if (error) {
    console.error('Error auto-adding products to monitoring:', error);
  } else {
    console.log(`Successfully added ${products.length} product(s) to monitoring`);
  }
};
